var _defs, _use, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 256 457.6           C 340 433.8 408.6 300.8 408.6 81           C 361 123 281.2 51.6 256 9.6           C 230.8 51.6 151 123 103.4 81           C 103.4 300.8 172 433.8 256 457.6           z",
    fill: "rgba(0, 0, 0, 1)",
    stroke: "rgba(0, 0, 0, 1)",
    strokeWidth: 12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 256 412.8           C 323.2 394.1 377 287.7 377 112.6           C 340 145.9 276.5 88 256 54.4           C 235.5 88 172 145.9 135 112.6           C 135 287.7 188.8 394.1 256 412.8           z",
    fill: "rgba(239, 239, 239, 1)",
    stroke: "rgba(239, 239, 239, 1)",
    strokeWidth: 12,
    strokeLinejoin: "round"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#shield",
    transform: "translate(-64, 0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#shield",
    transform: "translate(64, 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.4c35690b9575d8fdff64579927449ce2.svg";
export { ForwardRef as ReactComponent };